import { useQuery } from "@tanstack/react-query"
import { usePathname } from "next/navigation"

import { useLocale } from "@/modules/locales/useLocale"
import { getNotificationBanner } from "@/modules/notificationBanner/api/getNotificationBanner"
import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/notificationBanner/services/constants"
import { getNotificationBannerQueryKey } from "@/modules/notificationBanner/services/getNotificationBannerQueryKey"
import { isBackOfficePathname } from "@/modules/routing/helpers/isBackOfficePathname"

type UseNotificationBannerResponse = {
  data: Awaited<ReturnType<typeof getNotificationBanner>>
}

export const useNotificationBanner = (): UseNotificationBannerResponse => {
  const pathname = usePathname()
  const isBackend = isBackOfficePathname(pathname)
  const locale = useLocale()

  const { data } = useQuery({
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getNotificationBanner({ isBackend, locale }),
    queryKey: getNotificationBannerQueryKey({ isBackend, locale }),
    staleTime: QUERY_STALE_TIME,
  })
  // Return null to prevent error: Query data cannot be undefined.
  return { data: data || null }
}
